
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc';
import { UserService } from '../../modules/shared/services/user.service';
import { OAuthErrorEventParams } from './oAuthErrorEventParams';
import { AzureErrors } from './azureErrors';
import { PasswordResetUrl } from './passwordResetUrl';
import { AppAuthorization, DiscoveryDocumentConfig } from './app.authorization';
@Component({
    selector: 'app-access',
    imports: [RouterOutlet, RouterLink, RouterLinkActive],
    providers: [UserService],
    templateUrl: './access.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./access.component.scss']
})
export class AccessComponent implements OnInit {
  userName?: string;
  password?: string;
  loginFailed: boolean = false;
  userProfile?: object;
  user: any = { validUser: false };
  showInvalidUser: boolean = false;

  constructor(
    private router: Router,
    private oAuthService: OAuthService,
    private userService: UserService
  ) {
    this.configure();

    this.oAuthService.events.subscribe((e) => {
      if (e instanceof OAuthErrorEvent) {
        const parm = e.params as OAuthErrorEventParams;
        if (parm === null) return;
        if (parm.error === 'access_denied' && parm.error_description.includes(AzureErrors.RESET_PASSWORD)) {
          // redirect to forgot password flow
          window.location.replace(PasswordResetUrl);
        } else if (parm.error === 'access_denied' && parm.error_description.includes(AzureErrors.CANCELED_RESET_PASSWORD)) {
          // user has cancelled out of password reset
          this.oAuthService.initLoginFlow();
        }
      } else {
        switch (e.type) {
          case 'token_refreshed': {
            console.log('token_refreshed event happens');
            break;
          }
          case 'silently_refreshed': {
            console.log('silently_refreshed event happens');
            break;
          }
          case 'token_expires': {
            console.info('[INFO] token expired.');
            break;
          }
        }
      }
    });
  }

  private configure() {
    this.oAuthService.configure(AppAuthorization);
    this.oAuthService.tokenValidationHandler = new JwksValidationHandler();

    this.oAuthService.loadDiscoveryDocument(DiscoveryDocumentConfig.url).then((doc) => {
      this.oAuthService.tryLoginImplicitFlow({ disableOAuth2StateCheck: false }).then((_) => {
        this.userService.getUserProfiles().subscribe({
          next: (userFound) => {
            this.showInvalidUser = true;
            if (userFound != undefined) {

              if (!Array.isArray(userFound)) {
                userFound = [userFound];
              }

              userFound.forEach((element) => {
                if (element.clave.toLowerCase() == 'usuario autos') {
                  this.showInvalidUser = false;
                }
              });

              if (!this.showInvalidUser) {
                this.router.navigate(['home']);
              }

              //await this.checkIfUserExist(user[0].username);
              //this.showInvalidUser = !this.user.validUser;
            } else {
              this.showInvalidUser = true;
              sessionStorage.removeItem('access_token');
              sessionStorage.removeItem('id_token');
            }
          },
          error: (e) => {
            //this.customLogout();
            sessionStorage.removeItem('access_token');
            sessionStorage.removeItem('id_token');
            //this.router.navigate(['home']);
          },
        });

      });
    });
    this.oAuthService.setupAutomaticSilentRefresh();
  }

  ngOnInit() {
  }


  go() {
    //this.oAuthService.initLoginFlow()
    this.oAuthService.loadDiscoveryDocument(DiscoveryDocumentConfig.url).then((doc) => {
      // this.oauthService.initImplicitFlowInPopup().then(() => this.router.navigate(['home']))
      this.oAuthService.initLoginFlow();
    });
    //this.oauthService.loadDiscoveryDocumentAndLogin();
  }

  loadUserProfile(): void {
    this.oAuthService.loadUserProfile().then((up) => (this.userProfile = up));
  }

  get access_token() {
    return this.oAuthService.getAccessToken();
  }

  get access_token_expiration() {
    return this.oAuthService.getAccessTokenExpiration();
  }

  get givenName() {
    var claims = this.oAuthService.getIdentityClaims() as any;
    if (!claims) return null;
    return claims['given_name'];
  }

  get familyName() {
    var claims = this.oAuthService.getIdentityClaims() as any;
    if (!claims) return null;
    return claims['family_name'];
  }

  logout() {
    this.oAuthService.revokeTokenAndLogout();
  }
  private customLogout() {
    this.logout();
    this.router.navigate(['acceso']);
  }
}
